import * as createTerritory from "@/api/territories/create";

export default {
	namespaced: true,
	state: {
		territory: {},
		error: null,
	},
	getters: {
		readTerritory: (state) => state.territory,
		readError: (state) => state.error,
	},
	mutations: {
		SET_TERRITORY(state, payload) {
			state.territory = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async createTerritory({ commit, getters, rootGetters }) {
			let token = rootGetters["loginStore/readToken"];
			let createTerritoryRes = await createTerritory
				.createTerritory(token, getters.readTerritory)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return createTerritoryRes;
		},
	},
};
